import React, { ComponentProps } from 'react';
import { asBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { DefaultView, Views } from '../../types/BlockWithViews';
import { UserPageLeadDefaultView } from './views/UserPageLeadDefaultView';

type UserPageLeadProps = Views<DefaultView<UserPageLeadDefaultView>>;

function UserPageLead({ views }: UserPageLeadProps) {
  return views?.default ? <UserPageLeadDefaultView {...views.default} /> : null;
}

export const UserPageLeadBlock = asBlock(UserPageLead, BlockType.userpagelead);
export type UserPageLeadBlock = ComponentProps<typeof UserPageLeadBlock>;
